import React from 'react';
import classnames from 'classnames';
import themeConfig from '../configs/themeConfig';
import './styles.css';

const FullPageLayout = ({ children }) => {
  return (
    <div
      className={classnames(
        'full-layout wrapper bg-full-screen-image blank-page dark-layout',
        {
          'layout-dark': themeConfig.layoutDark
        }
      )}
    >
      <main className="main w-100">{children}</main>
    </div>
  );
};

export default FullPageLayout;
